import { FC, Fragment } from 'react';
import CellValue from '@app/shared/components/cell-value/CellValue';
import {
  amountRules,
  shortDateViewRules,
} from '@app/shared/components/cell-value/CellValueConfigurations';
import { useAppSelector } from '@core/hooks/redux-hooks';
import { useLocale } from '@app/core/hooks/useLocale';
import TableSectionValuesPerForecast from './TableSectionValuesPerForecast';
import TableSpacerRow from '@app/shared/components/table/TableSpacerRow';

type TableSectionValuesPerForecastEventProps = {
  columnsCount: number;
  testId?: string;
};

const TableSectionValuesPerForecastEvent: FC<TableSectionValuesPerForecastEventProps> = ({
  columnsCount,
  testId,
}) => {
  const { l } = useLocale();

  const waterfallCasesResults = useAppSelector(
    (state) => state.pwerm2Calculation.calculatedResults.waterfall.cases
  );

  const maximumNumberOfEvents = Object.values(waterfallCasesResults).reduce(
    (max, caseItem) =>
      Math.max(
        max,
        ...Object.values(caseItem.years).map(
          (forecast) => forecast.institutionalAdditions?.length ?? 0
        )
      ),
    0
  );

  if (maximumNumberOfEvents === 0) {
    return null;
  }

  return (
    <>
      <tr>
        <th className="table-primary__cell--header-tertiary">{l('_ForecastedInvestments')}</th>
        <th colSpan={columnsCount - 1} className="table-primary__cell--header-tertiary" />
      </tr>
      {Array.from(Array(maximumNumberOfEvents).keys()).map((eventsIndex) => (
        <Fragment key={eventsIndex}>
          <TableSectionValuesPerForecast
            title={l('_InfusionDate')}
            renderSpacer={false}
            testId={testId ? `${testId}-infusion-date-${eventsIndex}` : undefined}
            renderCell={({ caseItem, forecast }) => {
              const event =
                waterfallCasesResults[caseItem.caseId].years[forecast.forecastId]
                  .institutionalAdditions[eventsIndex];
              if (!event) {
                return null;
              }
              return <CellValue value={event.eventDate} {...shortDateViewRules} />;
            }}
          />
          <TableSectionValuesPerForecast
            title={l('_InfusionAmount')}
            renderSpacer={false}
            testId={testId ? `${testId}-infusion-amount-${eventsIndex}` : undefined}
            renderCell={({ caseItem, forecast }) => {
              const event =
                waterfallCasesResults[caseItem.caseId].years[forecast.forecastId]
                  .institutionalAdditions[eventsIndex];
              if (!event) {
                return null;
              }
              return <CellValue value={event.amount} {...amountRules} />;
            }}
          />
          <TableSpacerRow />
        </Fragment>
      ))}
    </>
  );
};
export default TableSectionValuesPerForecastEvent;
